module.exports = "/feedback_success-5a889bd38a8b16b389637c0a546aaade.svg";